import React from "react";
import Placeholder from "react-bootstrap/Placeholder";

const PlaceHolderLoader = () => {
  return (
    <div className="p-2">
      <Placeholder as="p" animation="glow">
        <Placeholder xs={12} />
        <Placeholder xs={6} />
      </Placeholder>
      <Placeholder as="p" animation="wave">
        <Placeholder xs={12} />
        <Placeholder xs={12} />
      </Placeholder>
    </div>
  );
};

export default PlaceHolderLoader;
